/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegisterCompanyByInvitationCodeRequest } from '../../models/register-company-by-invitation-code-request';

export interface RegisterCompanyByInvitationCode$Params {
  invitationCode: string;
      body: RegisterCompanyByInvitationCodeRequest
}

export function registerCompanyByInvitationCode(http: HttpClient, rootUrl: string, params: RegisterCompanyByInvitationCode$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, registerCompanyByInvitationCode.PATH, 'post');
  if (params) {
    rb.query('invitationCode', params.invitationCode, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

registerCompanyByInvitationCode.PATH = '/api/company/register-by-invitation-code';
